module.exports = __webpack_public_path__ + "static/media/S6_03.25db36c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE6strobe/S6_03.png
// module id = 205
// module chunks = 0